// extracted by mini-css-extract-plugin
export default {"root":"TipStuList_root__azeTi","overlay":"TipStuList_overlay__PvUpO","item":"TipStuList_item__jNUp3","num":"TipStuList_num__7DC2L"};